// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"21150dca","545":"53246855","548":"3048b96c","645":"8ee2f35e","662":"d5d64f01","719":"df4b48b9","744":"5c299343"}[chunkId] + ".chunk.js";
};